var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownlandOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linear/DownlandOutline"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 2.4C6.75 2.17909 6.57091 2 6.35 2H5C3.34315 2 2 3.34315 2 5V19C2 20.6569 3.34315 22 5 22H19C20.6569 22 22 20.6569 22 19V5C22 3.34315 20.6569 2 19 2H18.15C17.9291 2 17.75 2.17909 17.75 2.4V3.1C17.75 3.32091 17.9291 3.5 18.15 3.5H19L19.0881 3.50255C19.8755 3.54817 20.5 4.20116 20.5 5V19L20.4975 19.0881C20.4518 19.8755 19.7988 20.5 19 20.5H5L4.91186 20.4975C4.12446 20.4518 3.5 19.7988 3.5 19V5L3.50255 4.91186C3.54817 4.12446 4.20116 3.5 5 3.5H6.35C6.57091 3.5 6.75 3.32091 6.75 3.1V2.4ZM13 2.40001C13 2.17909 12.8209 2 12.6 2H11.9C11.6791 2 11.5 2.17908 11.5 2.39999L11.4998 13.034L8.16983 9.99108C7.91312 9.7565 7.5 9.93862 7.5 10.2864V11.2322C7.5 11.3445 7.54724 11.4517 7.63016 11.5274L11.689 15.2367C11.8457 15.3799 12.0454 15.4479 12.2429 15.4417C12.4402 15.4478 12.6397 15.3798 12.7963 15.2367L16.8699 11.5134C16.9528 11.4377 17 11.3305 17 11.2182V9.39978C17 9.39576 16.9984 9.3919 16.9956 9.38905C16.9898 9.38325 16.9805 9.38303 16.9745 9.38853L12.9998 13.02L13 2.40001Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownlandOutline);
export default __webpack_public_path__ + "static/media/downlandOutline.c637c63b4dbce843efe7938e35c83404.svg";
export { ForwardRef as ReactComponent };